import React from 'react';
import Base from './Base';

type ButtonProps = React.ComponentProps<typeof Base>;

const Secondary: React.FC<ButtonProps> = ({ className, ...rest }) => {
    const classes = ['btn--secondary', className].filter(Boolean).join(' ');
    return <Base className={classes} {...rest} />;
};

export default Secondary;


